import { IFrameMobileModal } from '@/components/modal'
import { ROUTE_ACCESSED_LOGGED, ROUTE_NOT_ACCESSED_LOGGED } from '@/constants/Routes'
import { useAppSelector } from '@/hooks/useRedux'
import { authSelector } from '@/pages/auth/selectors'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { drawerMenus } from './Menu'

type Props = {
  drawerOpen: boolean
  onDrawerToggle: () => void
}

export const DrawerMenu = ({ drawerOpen, onDrawerToggle }: Props) => {
  const { token } = useAppSelector(authSelector)

  const [openIframe, setOpenIframe] = useState(false)

  const onToggleIframe = () => setOpenIframe(!openIframe)

  return (
    <>
      {drawerOpen && (
        <div className="w-full fixed opacity-60 bg-slate-700 md:hidden h-full z-10" onClick={onDrawerToggle} />
      )}
      <div
        className={`w-3/5 bg-white md:hidden h-full fixed transition-all duration-500 ease-in-out pt-2 ${
          drawerOpen ? 'left-0' : 'left-[-24rem] sm:left-[-30rem]'
        } z-20`}
      >
        {drawerMenus.map((item) => {
          if (item.public && !item.href && item.title === 'Run Events')
            return (
              <div
                className="flex px-4 py-2 items-center cursor-pointer"
                key={item.title}
                onClick={() => {
                  onDrawerToggle()
                  onToggleIframe()
                }}
              >
                {item.icon}
                <span className="text-darkBlue font-robo font-normal ml-6 text-sm">{item.title}</span>
              </div>
            )

          if (item.public && item.href)
            return (
              <Link to={item.href} key={item.href} className="flex px-4 py-2 items-center" onClick={onDrawerToggle}>
                {item.icon}
                <span className="text-darkBlue font-robo font-normal ml-6 text-sm">{item.title}</span>
              </Link>
            )
          if (token && !item.public && ROUTE_ACCESSED_LOGGED.includes(item.href) && item.href)
            return (
              <Link to={item.href} key={item.href} className="flex px-4 py-2 items-center" onClick={onDrawerToggle}>
                {item.icon}
                <span className="text-darkBlue font-robo font-normal ml-6 text-sm">{item.title}</span>
              </Link>
            )

          // is not login
          if (!token && !item.public && ROUTE_NOT_ACCESSED_LOGGED.includes(item.href) && item.href)
            return (
              <Link to={item.href} key={item.href} className="flex px-4 py-2 items-center" onClick={onDrawerToggle}>
                {item.icon}
                <span className="text-darkBlue font-robo font-normal ml-6 text-sm">{item.title}</span>
              </Link>
            )

          return <React.Fragment key={item.href} />
        })}
      </div>
      <IFrameMobileModal open={openIframe} onClose={onToggleIframe} />
    </>
  )
}
